import {
    Autocomplete,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { REACT_APP_BACKEND_URL } from "../../Utils/Language/urlBase";
import { toast } from "react-toastify";
import AddOtherPartyDialog from "./AddOtherPartyDialog";

const AddStockDialog = ({
    isOpen,
    onClose,
    otherParties,
    stockLocations,
    item,
    authHeader,
    fetchCustomers,
}) => {
    const [batch, setBatch] = useState({
        quantityInitial: "",
        pricePurchase: "",
        expiryDate: "",
        stockLocationId: 0,
        otherPartyId: "",
    });

    const [isDisabled, setIsDisabled] = useState(false);
    const [isAddCustomerDialogOpen, setIsAddCustomerDialogOpen] =
        useState(false);

    const handleSubmit = async () => {
        setIsDisabled(true);
        const data = {
            otherPartyId: batch.otherPartyId,
            quantityInitial: batch.quantityInitial,
            pricePurchase: batch.pricePurchase,
            expiryDate: batch.expiryDate,
            stockLocationId: batch.stockLocationId,
            itemId: item.id,
        };
        const resp = await fetch(`${REACT_APP_BACKEND_URL}/stock/create`, {
            body: JSON.stringify(data),
            method: "POST",
            headers: {
                Authorization: authHeader,
                "Content-Type": "application/json",
            },
        });
        if (resp.ok) {
            await resp.json();
            setBatch({
                quantityInitial: "",
                pricePurchase: "",
                expiryDate: "",
                stockLocationId: "",
                otherPartyId: "",
            });
            onClose();
            toast.success("Stock added successfully");
        } else {
            toast.error("Something went wrong adding stock");
        }
        setIsDisabled(false);
    };

    return (
        <Dialog open={isOpen} onClose={onClose}>
            {authHeader && isAddCustomerDialogOpen && (
                <AddOtherPartyDialog
                    isOpen={isAddCustomerDialogOpen}
                    onClose={() => {
                        if (fetchCustomers) {
                            fetchCustomers();
                        }
                        setIsAddCustomerDialogOpen(false);
                    }}
                    authHeader={authHeader}
                />
            )}
            <DialogTitle>Add Stock {item.name}</DialogTitle>
            <DialogContent>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        py: "10px",
                    }}
                >
                    <TextField
                        value={batch.quantityInitial}
                        onChange={(e) =>
                            setBatch({
                                ...batch,
                                quantityInitial: e.target.value,
                            })
                        }
                        label="Quantity"
                        size="small"
                        type="number"
                    />
                    <TextField
                        value={batch.pricePurchase}
                        onChange={(e) =>
                            setBatch({
                                ...batch,
                                pricePurchase: e.target.value,
                            })
                        }
                        label="Purchase Price"
                        size="small"
                        type="number"
                    />
                    <TextField
                        value={batch.expiryDate}
                        onChange={(e) =>
                            setBatch({ ...batch, expiryDate: e.target.value })
                        }
                        label="Expiry Date"
                        size="small"
                        type="date"
                        InputLabelProps={{ shrink: true }}
                    />
                    <Autocomplete
                        disablePortal
                        value={stockLocations.find(
                            (loc) => loc.id === batch.stockLocationId
                        )}
                        onChange={(e, newValue) => {
                            setBatch({
                                ...batch,
                                stockLocationId: newValue?.id,
                            });
                        }}
                        size="small"
                        options={stockLocations}
                        getOptionLabel={(option) => option.name}
                        renderInput={(params) => (
                            <TextField {...params} label="Stock Location" />
                        )}
                    />
                    <Autocomplete
                        disablePortal
                        value={otherParties.find(
                            (party) => party.id === batch.otherPartyId
                        )}
                        onChange={(e, newValue) => {
                            if (newValue?.id === 0) {
                                setIsAddCustomerDialogOpen(true);
                            } else {
                                setBatch({
                                    ...batch,
                                    otherPartyId: newValue?.id,
                                });
                            }
                        }}
                        size="small"
                        options={[
                            ...otherParties,
                            { id: 0, name: "Add Other Party +" },
                        ]}
                        getOptionLabel={(option) => option.name}
                        renderInput={(params) => (
                            <TextField {...params} label="Other Party" />
                        )}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="error">
                    Cancel
                </Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    disabled={isDisabled}
                >
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddStockDialog;
